import React from 'react';
export function BonusSection() {
  return <section className="py-6 px-4 bg-gradient-to-b from-yellow-50 to-white" data-id="element-46">
      <div className="max-w-4xl mx-auto" data-id="element-47">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-2" data-id="element-48">
          🎁 Y ADEMÁS TE LLEVAS GRATIS:
        </h2>
        <p className="text-2xl font-bold text-red-600 text-center mb-6" data-id="element-49">
          ¡GRATIS POR EL DÍA DE HOY!
        </p>

        <div className="grid md:grid-cols-3 gap-4 mb-6" data-id="element-50">
          <a href="#compra" className="block hover:scale-105 transition-transform duration-300" data-id="element-51">
            <img src="https://cdn.magicpatterns.com/uploads/fs9NUoVgHwHkCwjbsFpt9T/mockup_bono1.png" alt="Bono 1 - Juegos financieros" className="w-full aspect-square object-cover rounded-lg shadow-lg cursor-pointer" data-id="element-52" />
            <div className="mt-2 text-center" data-id="element-53">
              <h3 className="text-xl font-black mb-1" data-id="element-54">
                🎲 BONO 1: Juegos financieros
              </h3>
              <p className="text-lg" data-id="element-55">👉 Para aprender jugando</p>
            </div>
          </a>

          <a href="#compra" className="block hover:scale-105 transition-transform duration-300" data-id="element-56">
            <img src="https://cdn.magicpatterns.com/uploads/nJTkSAEn3iWBWtgBt3gfz2/mockup_bono2.png" alt="Bono 2 - Guía rápida para padres sin tiempo" className="w-full aspect-square object-cover rounded-lg shadow-lg cursor-pointer" data-id="element-57" />
            <div className="mt-2 text-center" data-id="element-58">
              <h3 className="text-xl font-black mb-1" data-id="element-59">
                ⏱️ BONO 2: Guía rápida para padres sin tiempo
              </h3>
              <p className="text-lg" data-id="element-60">👉 Solo 10 minutos al día</p>
            </div>
          </a>

          <a href="#compra" className="block hover:scale-105 transition-transform duration-300" data-id="element-61">
            <img src="https://cdn.magicpatterns.com/uploads/4peSs4xABrtE4iKGT8eg5m/mockup_bono3.png" alt="Bono 3 - Plantillas listas para usar" className="w-full aspect-square object-cover rounded-lg shadow-lg cursor-pointer" data-id="element-62" />
            <div className="mt-2 text-center" data-id="element-63">
              <h3 className="text-xl font-black mb-1" data-id="element-64">
                📊 BONO 3: Plantillas listas para usar
              </h3>
              <p className="text-lg" data-id="element-65">👉 Sistema práctico inmediato</p>
            </div>
          </a>
        </div>
      </div>
    </section>;
}
export default BonusSection;